import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { filter, keyBy, map } from 'lodash';

import { patientFormTemplatesResource } from '@lib/resources';

import FilterList from '../FilterList';

interface Props {
  classes: any;
}
const FilterFeedbackForms: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const patientFormTemplates = useSelector(patientFormTemplatesResource.selectEntitiesObj);
  // @ts-ignore
  const prequalFilter = map(filter(patientFormTemplates, { type: 'feedback' }), (template: any) => ({
    id: template._id,
    name: template.title,
  }));

  useEffect(() => {
    dispatch(patientFormTemplatesResource.fetchList());
  }, [dispatch]);

  const allItems = keyBy(prequalFilter, 'id');
  // @ts-ignore
  return <FilterList items={prequalFilter} allItems={allItems} {...props} />;
};

export default FilterFeedbackForms;
